var View = require('views/base/view');
import SessionStorageService from 'services/web-storage-service/session-storage-service';
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');
var FeedbackService = require('services/feedback-service');

var InputItemView = View.extend({
  autoRender: true,
  listen: {
    'addedToParent': 'load'
  },
  attributes : function() {

    // Return model data
    let wrapper_class = this.model.get( 'wrapper_class' ) || '';
    return {
      class : 'input-list-item input-'+this.model.get( 'type' ) + ' ' + wrapper_class,
    };
  },
  initialize: function() {
    if(!this.model.get('id')) {
      this.model.set('id',this.model.cid);
    } 

    if(this.model.get('type') === 'number') {
      const toggle = function({target}) {
        const decreaseButton = document.getElementById(`decreaseButton-${this.model.get('id')}`);   
        const increaseButton = document.getElementById(`increaseButton-${this.model.get('id')}`);
        if(target.value >= this.model.get('max_value')) {
          increaseButton.setAttribute('disabled', 'disabled');
        } 
        if(target.value >  this.model.get('min_value')) {
          decreaseButton.removeAttribute('disabled');
        }
        if(target.value <= this.model.get('min_value')) {
          decreaseButton.setAttribute('disabled', 'disabled');
        } 
        if(target.value < this.model.get('max_value')) {
          increaseButton.removeAttribute('disabled');
        }
      }
      this.delegate('change',`#${this.model.get('id')}`, (e) => {
        toggle.call(this, e);
      });
      this.delegate('click', '.increase_num', (e) => {
        const input = document.getElementById(this.model.get('id'));
        this._setInputValue(input, 'up');
        this.model.set('value', input.value);
        $(e.target).attr('aria-label', `${LocaleService.t('input.number.increaseBtn')} ${this.model.get('value')}`);
        AhoyService.track('input-item', {action: 'increase', id: this.model.get('id'), value: this.model.get('value')});
        Chaplin.mediator.publish('block:values:change', {
          id: this.model.get('id'),
          value: this.model.get('value')
        }, this, this.pageView);
        toggle.call(this, {target: input});
      });
      this.delegate('click', '.decrease_num', (e) => {
        const input = document.getElementById(this.model.get('id'));
          this._setInputValue(input, 'down');
          this.model.set('value', input.value);
          $(e.target).attr('aria-label', `${LocaleService.t('input.number.decreaseBtn')} ${this.model.get('value')}`);
          AhoyService.track('input-item', {action: 'decrease', id: this.model.get('id'), value: this.model.get('value')});
          Chaplin.mediator.publish('block:values:change', {
            id: this.model.get('id'),
            value: this.model.get('value')
          }, this, this.pageView);
          toggle.call(this, {target: input});
      });
    }

    if(this.model.get('session_value')) {
      var val = SessionStorageService.getByDotString(this.model.get('session_value'));
      this.model.set('value', val);
      this.model.set('default_value', val);
    }

    if(this.model.get('type') === 'range') {
      this.value = 0;
      this.moving = false;
      this.required = 0;
      this.slider = this.model.get('slider');

      if(typeof this.slider.points === 'number') {
        this.slider.points =  [...Array(++this.slider.points)].map((_,e) => {
          return {index: e};
        });
      }
    }

    this.delegate('change', (e) => {
      let value_changed = true;
      const value = $(e.target).val();
      if($(e.target).attr('type') === 'number') {
        // If the form does have validation on submit
        if(!$(e.target).parents('.validate_on_submit').length) {
          //validates input manual entries
          if(!this._validate()) {
            //revert back to old value if not a valid input
            $(e.target).val(this.model.get('value'));
            value_changed = false;
          } 
        }
      }  
      if(value_changed) {
        AhoyService.track('input-item', {action: 'change', id: this.model.get('id'), value});
        Chaplin.mediator.publish('block:values:change', {
          id: this.model.get('id'),
          value
        }, this, this.pageView);
        this.model.set('value', value);
      }
    });
  },
  _stepFallback: function(input, direction) {
    let inputResult = Number(input.value);
    const directionModifier = direction === 'down' ? -1 : 1;
    inputResult += directionModifier;
    input.value = inputResult;
  },
  _setInputValue: function(input, direction) {  
    if(typeof input.stepUp === 'function' && typeof input.stepDown === 'function') {          
      try {
          if(direction === 'down') {
            input.stepDown();
          } else {
            input.stepUp();
          }              
      } catch(err) {
          this._stepFallback(input, direction);
      }          
    } else {
      this._stepFallback(input, direction);
    }
  },  
  load: function() {
    if(this.model.get('type') === 'date') {
      const $datePicker = this.$el.find('[type="date"]');
      // fallback for browsers that don't support `type='date'`: Safari & IE
      if($datePicker && $datePicker.get(0).type !== 'date') {
        if(!$datePicker.prop('pattern')) {
          $datePicker.attr({'pattern': '\d{1,2}/\d{1,2}/\d{4}'});
        }
      }
    }

    if(this.model.get('type') === 'select') {
      if(this.model.get('selected_index')) {
        this.$el.find(`select option:nth-of-type(${this.model.get('selected_index')})`).prop('selected', true);
      }

      if(this.model.get('selected_value')) {
        this.$el.find(`select option[value="${this.model.get('selected_value')}"]`).prop('selected', true);
      }
    }

    if(this.model.get('type') === 'toggle') {
      this.delegate('click', (e) => {
        if(e.target.tagName === 'INPUT') {
          this.model.set('checked', !this.model.get('checked'));
          AhoyService.track('input-item', {action: 'toggle', id: this.model.get('id'), value: $(e.target).val(), checked: this.model.get('checked')});

          Chaplin.mediator.publish('block:values:change', {
            id: this.model.get('id'),
            value: $(e.target).val(),
            collection: this.model.collection.models.reduce((collection, model) => {
              if(model.get('checked') === true && model.get('value')) {
                collection.push(model.get('value'));
              }
              return  collection;
            }, [])
          }, this, this.pageView);
          this.render();
        }
      });
    }

    if(this.model.get('type') === 'select') {
      this.model.set('value', this.$el.find('option:selected').val());
    }

    if(this.model.get('type') === 'range') {

      this.slider.$wrapper = this.$el.find(`#${this.model.get('id')}`);
      this.slider.$element = this.$el.find('.slider[data-subject="' + this.slider.subject + '"]');
      this.slider.$input = this.slider.$element.find('input');
      this.slider.$output = this.$el.find('.' + this.slider.output_class);

      this.slider.$wrapper.css({
        '-webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none'
      });

      if(this.slider.required) {
        this.required++;
      }

      this.slider.value = this.slider.value || this.slider.min;

      this.initAttributes(this.slider);
      this.updateAria(this.slider);

      if(this.slider.show_button_value) {
        if(this.slider.output_class) {
          this.slider.$output.text(this.slider.value);
        } else {
          this.slider.$input.parent().append('<span class="feedbackBubble" style="position:absolute;">' + this.slider.value + '</span>');
        }
      }

      this.delegate('change input', 'input', function(e) {
        e.preventDefault();
        var slider = this.slider;
        var selectedPoint = slider.points[e.currentTarget.valueAsNumber];

        if(!selectedPoint) {
          // console.error('Your step setting seems to exceed the amount of points set up in your yml.');
          return false;
        }

        if(slider.required && slider.visitAllPoints) {
          if(slider.visited && (e.currentTarget.valueAsNumber !== slider.visited[slider.visited.length-1])) {
              let val;
              if(selectedPoint.index > (slider.visited.length-1)) { // clicked/dragged to the right of current loc
                val = slider.points[slider.visited.length] ? slider.points[slider.visited.length].value : slider.points[slider.points.length-1].value;
              } else if(selectedPoint.index < (slider.visited.length-1)) { // clicked/dragged to the left of current loc
                val = slider.points[slider.visited.length-2] ? slider.points[slider.visited.length-2].value : slider.points[0].value;
                slider.visited.splice(-1,1);
              }
              if(val) {
                selectedPoint = this.getClosestByValue(slider.points, val);
                this.changeValue(slider, selectedPoint);
              }
          }
        } else {
          this.changeValue(slider, selectedPoint);
        }
        this.toggleSlider();
      });

      this.delegate('mousedown touchstart', '.slider-step', function(e) {
        e.stopPropagation();
        let target = $(e.currentTarget);
        var slider = this.slider;
        if(slider.enable_step_buttons) {
          if(target.attr('data-change') === 'decrement' && slider.currentPoint.index > 0) {
            e.preventDefault();
            this.startChanging(slider);
            $('.slider-step.minus').attr('aria-label', LocaleService.t('slider.decrementBtn') + ' ' + (slider.value - slider.step));
          } else if(target.attr('data-change') === 'increment' && slider.currentPoint.index < slider.points.length) {
            e.preventDefault();
            this.startChanging(slider, true);
            $('.slider-step.plus').attr('aria-label', LocaleService.t('slider.incrementBtn') + ' ' + (slider.value + slider.step));
          }
        }
        this.toggleSlider();
      });

      var resizeHandler = _.debounce(this.setSliderData, 200);
      this.setSliderData(this.slider, true);
      window.addEventListener('resize', () => resizeHandler(this.slider));
    }
  },
  render: function() {
    View.prototype.render.apply(this, arguments);
    let translatable = this.model.get('translate');
    this.model.property('attributes', (attributes) => {
      Object.keys(attributes).forEach((key) => {
        this.$('[data-attributable]').attr(key,
          Array.isArray(translatable) && translatable.includes(key) ? LocaleService.t(attributes[key]) : attributes[key]
        );
      });
      this.$('[data-attributable]').removeAttr('data-attributable');
    });
  },
  getTemplateFunction: function() {
    return require('./templates/' + this.model.get('type'));
  },
  _validate: function() {
    const $el = $($(this.el).children('input')[0]); // Returning the input as a jQuery object.
    const value = $el.val();
    const min = $el.attr('min');
    const max = $el.attr('max');
    const pattern = $el.attr('pattern');
    let validate = true;

    if(value) {
      if(pattern && !RegExp(pattern).test(value)) validate = false;
      if(min != undefined && parseInt(value, 10) < parseInt(min, 10)) validate = false;
      if(max != undefined && parseInt(value, 10) > parseInt(max, 10)) validate = false;
    }
    return validate;
  },
  _validateOnSubmit: function() {
    if(!this._validate()) {
      const max = this.model.get('max_value');
      const min = this.model.get('min_value');
      const fieldName = LocaleService.t( this.model.get('label') ); 

      if( min && max ) {
        return LocaleService.t('inputErrorMessages.desc_between', { fieldName, min, max });
      }

      if( min ) {
        return LocaleService.t( 'inputErrorMessages.desc_higher', { fieldName, min });
      }

      return LocaleService.t( 'inputErrorMessages.desc_lower', { fieldName, max } );
    }

    return null;
  },
  initAttributes: function(slider) {
      const range = slider.max-slider.min;
      this.slider.$input.attr({'max': range / slider.step});
  },
  updateAria: function(slider) {
      this.slider.$input.attr({
          'data-percent': slider.value * 100 / slider.max,
          'data-state': slider.value,
          'data-ratio': slider.value / slider.step
      });
  },
  startChanging: function(slider, increment) {
    let selectedPoint;
    if(increment) {
      selectedPoint = slider.points[slider.currentPoint.index+1] ? slider.points[slider.currentPoint.index+1] : slider.points[slider.points.length-1];
    } else {
      selectedPoint = slider.points[slider.currentPoint.index - 1] ? slider.points[slider.currentPoint.index - 1] : slider.points[0];
    }
    this.changeValue(slider, selectedPoint);
  },
  handleFeedbackBubble: function(slider, selectedPoint) {
    let newPoint, newPlace, offset;
    const width = this.slider.$element.width();
    const value = this.slider.$input.val(); // this value should be something between 0 and the max="" on the element, not the min/max in the yml

    newPoint = (selectedPoint.value - slider.min) / (slider.max - slider.min);
    offset = -1.2; // because <input slide=range is inaccurate\

    if(newPoint < 0) {
      newPlace = 0;
    } else if(newPoint > 1) {
      newPlace = width;
    } else {
      (newPlace = width * newPoint + offset);
      offset -= (newPoint * -(offset*3));
    }

    const val = (value * slider.step) + slider.min;
    this.slider.$element.parent().find('span.feedbackBubble').css({
        left: newPlace,
        marginLeft: offset + '%'
    }).text(val);

    this.slider.$element.parent().find('.slider-thumb-horizontal').css({
        left: newPlace,
        marginLeft: offset + '%'
    });
  },
  getClosestByValue: function(arr, val) {
    if(val < 0.1) return arr[0];
    return arr.reduce(function(prev, curr) {
      if(prev.value) {
        return (Math.abs(curr.value - val) < Math.abs(prev.value - val) ? curr : prev);
      } else {
        return curr;
      }
    });
  },
  setSliderData: function(slider, initialize) {
    var leftMost = slider.left || 0;
    var rightMost = slider.right || this.slider.$element.width();
    var step = rightMost / slider.points.length;
    var position = leftMost;
    var value = slider.min;

    slider.points.forEach(function(point, index) {
      point.position = position;
      point.value = point.value || value;
      point.index = index;
      value = point.value + slider.step;
      position += (step + ( step / slider.points.length));
    });

    //code for sliders and condition added to check undefined behaviour for slider value
    var matchedSliderPoint = _.find(slider.points, function(e) {
      return e.value === slider.value;
    });

    if(matchedSliderPoint === undefined) matchedSliderPoint = slider.points[0];

    if(initialize) {
      this.changeValue(slider, matchedSliderPoint);
    } else {
      this.changeValue(slider, slider.currentPoint);
    }
  },
  changeValue: function(slider, selectedPoint) {

      this.slider.$input.attr({
        'data-state': selectedPoint.value
      });

      this.updateAria(slider);

      if(selectedPoint.description) {
        this.slider.$input.attr('aria-valuetext', LocaleService.t(selectedPoint.description));
      }

      slider.currentPoint = selectedPoint;
      slider.visited = slider.visited || [];
      this.slider.$input.val(selectedPoint.index);
      slider.value = selectedPoint.value;

      if(!_.includes(slider.visited, selectedPoint.value)) {
        slider.visited.push(selectedPoint.value);
      }

      var values = {};
      values[slider.subject] = slider.value;

      if(slider.show_button_value) {
        if(slider.output_class) {
          this.slider.$output.text(slider.value);
        } else {
          this.handleFeedbackBubble(slider, selectedPoint);
        }
        this.slider.$input.trigger('valuechanged', slider.value);
      }
      AhoyService.track('input-range', {action: 'move', subject: slider.subject, value: slider.value});

      var feedback = FeedbackService.matchFeedback(this.model.get('feedbacks'), values);
      FeedbackService.renderFeedbackWithElementState(feedback, this.slider.$element, 'correct', [ 'correct' ]);
      Chaplin.mediator.publish('block:values:change', values, this, this.pageView);
      this.checkComplete();
  },
  _increment: function(slider, direction) {
    this.changeValue(slider, slider.points[slider.currentPoint.index + direction]);
  },
  checkComplete: function() {
    if(this.model.get('state') === 'completed') {
      return;
    }
    var required_completed = 0;

    if(this.slider.required) {
      if(this.slider.visited) {
        var amountRequired = (this.slider.visitAllPoints) ? this.slider.points.length : 2;
        if(this.slider.visited.length >= amountRequired) {
          required_completed++;
        }
      }
    }
    if(this.required !== 0 && required_completed === this.required) {
      AhoyService.track('input-range', {action: 'completed'});
    }
  },
  toggleSlider: function() {
    if(this.slider.currentPoint.value <= this.slider.min) {
      $('.slider-step.minus').attr('disabled', 'disabled');
    }
    if(this.slider.currentPoint.value > this.slider.min) {
      $('.slider-step.minus').removeAttr('disabled');
    }
    if(this.slider.currentPoint.value >= this.slider.max) {
      $('.slider-step.plus').attr('disabled', 'disabled');
    }
    if(this.slider.currentPoint.value < this.slider.max) {
      $('.slider-step.plus').removeAttr('disabled');
    }
  }
});

module.exports = InputItemView;
